<template>
    <kiosk-team-details :teamId="props.teamId">
        <div class="flex flex-col w-full justify-center">
            <imports-list
                :context="{ teamId: props.teamId }"
                embedded
                importType="user"
                :newImportHref="`/kiosk/teams/${props.teamId}/users/imports/new`"
                :readOnly="team.status === 'closed'"
            >
                <template v-slot:title>User Imports</template>
            </imports-list>
        </div>
    </kiosk-team-details>
</template>

<script setup>
import KioskTeamDetails from '../details/KioskTeamDetails.vue';
import ImportsList from '~/components/import/ImportsList.vue';
import { useTeamDetails } from '../composables/useTeamDetails';

const props = defineProps({
    teamId: {
        type: Number,
        required: true,
    },
});

const { team } = useTeamDetails();
</script>
